import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Template } from '../../Components/Template/template'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { Link, useParams } from 'react-router-dom'
import {
    AlertType, Cidade, ClientesAttributes, ContatoCliente, DadosCNPJ, Estado, barraVermelhoAzul, bgBlue, bgRed, focusLabelRed, focusRed,
    classBorderLabelDark, classBt, classDivBackground, classDivBody, classInput, classInputDark, classLabel, classLabelDark, classWeigthBt,
    classbtAzul, classbtCinzaClaro, classbtColunasAzul, classbtColunasVermelho, classUserCriarAtt, classDtCriarAtt, InputsRefs,
} from '../../Utils/Types'
import { IoSave } from 'react-icons/io5'
import { FcNook } from 'react-icons/fc'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faEnvelope, faFolder, faClipboardList } from '@fortawesome/free-solid-svg-icons'
import { Icone } from '../../Components/Icones/Index'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import { ClientesService } from './ClientesService'
import { ModalConsultaCNPJ } from '../../Components/ModalConsultaCNPJ/modal-consulta-cnpj'
import InputMask from 'react-input-mask';

import { cpf, cnpj } from 'cpf-cnpj-validator'
import moment from 'moment'
import { SearchBox } from '../../Components/SearchBox/SearchBox'
import { Funcoes } from '../../Utils/Funcoes'
import { ModalExcluirDados } from '../../Components/Modal/ModalExcluirDados'
import { ModalAuditoria } from '../../Components/ModalAuditoria/modal_auditoria'
import { UtilServices } from '../../Utils/UtilServices'
import { AiOutlineClear } from 'react-icons/ai'
import { FaFileDownload, FaRegQuestionCircle, FaVideo } from 'react-icons/fa'
import { Tooltip } from 'react-tooltip'
import { ModalImportacao } from '../../Components/Modal/modalImportacao'
import { useSelector } from 'react-redux'
import { selectUser } from '../../Components/Redux/userSlice'
import { GridContatoCliente } from '../../Components/GridProducts/GridContatoCliente'
import { ModalTutorial } from '../../Components/Modal/modal-tutorial'

type CampoObrigatorio = {
    campo: string,
    erro: boolean,
}

type MaskedInputProps = React.ComponentProps<typeof InputMask>;

export const ClienteNew = () => {

    // ----------------- TABS --------------------------------------------------------
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        { index: 1, titulo: 'Contatos', active: false, icon: faEnvelope },
        { index: 2, titulo: 'Auditoria', active: false, icon: faClipboardList },
    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)


    // ------------- CAMPOS OBRIGATORIOS ----------------------------------------------
    const fieldsMandatory: CampoObrigatorio[] = [
        { campo: 'cnpj_cpf', erro: false },     // Posição 0 do Array.
        { campo: 'nome', erro: false },         // Posição 1 do Array.
        { campo: 'ie_rg', erro: false },        // Posição 2 do Array.
        { campo: 'endereco', erro: false },     // Posição 3 do Array.  
        { campo: 'bairro', erro: false },       // Posição 4 do Array.  
        { campo: 'estado', erro: false },       // Posição 5 do Array. 
        { campo: 'cidade', erro: false },       // Posição 6 do Array. 
    ]

    const [CamposObrigatorios, setCamposObrigatorios] = useState<CampoObrigatorio[]>(fieldsMandatory)


    // ------------------ ATRIBUTOS ---------------------------------------------------
    const { idCliente } = useParams<string>()
    const [id, setId] = useState(0)
    const [attributes, setAttributes] = useState<ClientesAttributes>()

    // COLUNA 1 
    const [tipoPessoa, setTipoPessoa] = useState("F")
    const [cpfCnpj, setCpfCnpj] = useState("")
    const [nomeRazao, setNomeRazao] = useState("")
    const [nomeRazaoCopia, setNomeRazaoCopia] = useState("")
    const [nome_fantasia, setNomeFantasia] = useState("")
    const [ieRg, setIeRg] = useState("")
    const [ativo, setAtivo] = useState("S")
    const [dtNascimento, setDtNascimento] = useState("")
    const [observacao, setObservacao] = useState("")


    // COLUNA 2 
    const [cep, setCep] = useState<string>("")
    const [endereco, setEndereco] = useState("")
    const [bairro, setBairro] = useState("")
    const [numero, setNumero] = useState("")
    const [complemento, setComplemento] = useState("")
    const [idUf, setIdUf] = useState(0)
    const [uf, setUf] = useState<Estado[]>([])
    const [siglaUf, setSiglaUf] = useState("")
    const [idCity, setIdCity] = useState(0)
    const [cidade, setCidade] = useState<Cidade[]>([])

    // ---------- ATRIBUTOS CONTATO --------------------------------------------------
    const [cliente, setCliente] = useState<ContatoCliente[]>([])
    const [idContato, setIdContato] = useState(0)
    const [nomeContatoCli, setNomeContatoCli] = useState("")
    const [nomeContatoExcluir, setNomeContatoExcluir] = useState("")
    const [emailContatoCli, setEmailContatoCli] = useState("")
    const [descricaoContatoCli, setDescricaoContatoCli] = useState("")
    const [foneContatoCli, setFoneContatoCli] = useState("")
    const [celContatoCli, setCelContatoCli] = useState("")
    const [listContato, setListContato] = useState<ContatoCliente[]>([])

    // ---------- ATRIBUTOS FEEDBACK -------------------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- ATRIBUTOS EXCLUSÃO --------------------------------------------------
    const [loadingExcluir, setLoadingExcluir] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [idExcluir, setIdExcluir] = useState(0)

    // ---------- ATRIBUTOS AUDITORIA -------------------------------------------------
    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")

    // ---------- ATRIBUTOS AUDITORIA CONTATO -----------------------------------------
    const [listAuditoriaContato, setListAuditoriaContato] = useState<ContatoCliente>()

    // ---------- MODALS --------------------------------------------------------------
    const [modalConsultaVisible, setModalConsultaVisible] = useState(false)
    const [modalAuditoriaVisible, setModalAuditoriaVisible] = useState(false)

    // --------- lOADING --------------------------------------------------------------
    const [loadingCnpj, setLoadingCnpj] = useState(false)
    const [loadingConsultaCEP, setLoadingConsultaCEP] = useState<boolean>(false)

    // --------- SEARCHBOX ------------------------------------------------------------
    const [visibleSearchBoxUF, setVisibleSearchBoxUF] = useState<boolean>(false)
    const [visibleSearchBoxCity, setVisibleSearchBoxCity] = useState<boolean>(false)

    // -------- IMPORTAÇÃO ------------------------------------------------------------
    const [visibleImportacao, setVisibleImportacao] = useState<boolean>(false)

    // -------- TEMA ------------------------------------------------------------------
    let user = useSelector(state => selectUser(state))

    // ---------- ATRIBUTOS TUTORIAL ----------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ATRIBUTOS E EFFECT --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ || 
    const dadosEmpresaLogada = () => {
        const dadosEmpresa = Funcoes.GetDadosEmpresa()

        if (dadosEmpresa !== null) {

            const dadosLocalStorage = dadosEmpresa

            const ufEmpresa = dadosLocalStorage.uf

            const estado = [...attributes?.estados || []].filter((uf) => uf.sigla === ufEmpresa)

            if (estado && estado.length > 0) {
                setIdUf(estado[0].id)
                setarCidades(estado[0].sigla)
                setSiglaUf(estado[0].sigla)
            }
        }
    }

    const getAttributes = async () => {
        setLoading(true)

        try {

            const attr = await ClientesService.GetAttributes(idCliente)

            setAttributes(attr.data)
            setUf(attr.data.estados)
            //setCidade(attr.cidades)

            const dadosEmpresa = Funcoes.GetDadosEmpresa()

            if (dadosEmpresa !== null) {

                const dadosLocalStorage = dadosEmpresa

                const ufEmpresa = dadosLocalStorage.uf

                const estado = attr.data.estados.filter((uf: any) => uf.sigla === ufEmpresa)

                if (estado && estado.length > 0) {
                    setIdUf(estado[0].id)
                    setarCidades(estado[0].sigla)
                    setSiglaUf(estado[0].sigla)
                }
            }

            if (attr.data && idCliente) {

                const citys = attr.data.cidades.filter((item: any) => item.id === attr.data.cliente?.id_cidade)
                if (citys && citys.length > 0) {
                    setIdCity(citys[0].id)
                }

                const estado = attr.data.estados.filter((uf: any) => uf.sigla === attr.data.cliente?.uf)
                if (estado && estado.length > 0) {
                    setIdUf(estado[0].id)
                }

                setId(attr.data.cliente.id || 0)
                setTipoPessoa(attr.data.cliente.tipo_pessoa || 'F')
                setCpfCnpj(attr.data.cliente.cnpj_cpf || '')
                setNomeRazao(attr.data.cliente.nome || '')
                setNomeRazaoCopia(attr.data.cliente.nome || '')
                setNomeFantasia(attr.data.cliente.nome_fantasia || '')
                setDtNascimento(attr.data.cliente.dt_nascimento || '')
                setIeRg(attr.data.cliente.ie_rg || '')
                setAtivo(attr.data.cliente.ativo || 'S')
                setObservacao(attr.data.cliente.observacao || '')

                setCep(attr.data.cliente.cep?.toString() || '')
                setEndereco(attr.data.cliente.endereco || '')
                setBairro(attr.data.cliente.bairro || '')
                setNumero(attr.data.cliente.numero?.toString() || "")
                setComplemento(attr.data.cliente.complemento || '')
                setSiglaUf(attr.data.cliente.uf || '')
                
                if (attr.data.cliente.dt_cadastro) {
                    const dataFormatadaCriacao = moment(attr.data.cliente.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (attr.data.cliente.dt_last_update) {
                    const dataFormatadaAtt = moment(attr.data.cliente.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setUserCriador(attr.data.cliente.name_user_insert || '')
                setUsertAtt(attr.data.cliente.name_user_last_update || '')
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível carregar os dados`)

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAttributes()
        uppContacts()
        inputFocus()
    }, [])

    useEffect(() => {
        const newCitys = attributes?.cidades.filter((item: Cidade) => {
            return item.uf.trim() === (attributes?.cliente?.uf.trim() || siglaUf)
        })

        setCidade(newCitys || [])
    }, [attributes])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
        searchBoxFocus()
    }

    useEffect(() => {

        if (tabs[0].active) {
            inputFocus()
        } else {
            InputfocusContato()
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- INPUTS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const tipoPessoaChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipoPessoa(e.target.value)
    }

    const cpfCnpjChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value.replaceAll('.', '').replaceAll('_', '').replaceAll('-', '').replaceAll('/', '')
        setCpfCnpj(inputValue)
    }

    const nomeRazaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNomeRazao(e.target.value)
    }

    const fantasiaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNomeFantasia(e.target.value)
    }

    const ieRgChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIeRg(e.target.value)
    }

    const ativoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setAtivo(e.target.value)
    }

    const dtNascimentoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDtNascimento(e.target.value)
    }

    const observacaoChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setObservacao(e.target.value)
    }

    const cepChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value.replaceAll('_', '').replaceAll('-', '')
        setCep(inputValue)

        if (e.target.value && Funcoes.onlyNumber(e.target.value).length === 8) {
            handleConsultaCEP(e.target.value)
        } else if (e.target.value && Funcoes.onlyNumber(e.target.value).length === 0) {

            setEndereco('')
            setBairro('')
            setNumero('')
            setComplemento('')
            setIdCity(0)
            dadosEmpresaLogada()

            updateUfList()
        }
    }

    const handleConsultaCEP = async (cep: string) => {

        setVisible(false)
        setLoadingConsultaCEP(true)

        try {

            const dadosCEP = await Funcoes.ConsultaCEP(cep)

            if (dadosCEP.error) {

                dadosEmpresaLogada()
                setIdCity(0)
                setBairro('')
                setComplemento('')
                setEndereco('')

            } else {

                updateUfList()

                const estado = [...attributes?.estados || []].filter((item) => item.sigla === dadosCEP.data.uf)
                if (estado && estado.length > 0) {
                    setIdUf(estado[0].id)
                    setarCidades(estado[0].sigla)
                    setSiglaUf(estado[0].sigla)
                }

                const cidade = [...attributes?.cidades || []].filter((item) => item.id === dadosCEP.data.ibge)
                if (cidade && cidade.length > 0) {
                    setIdCity(cidade[0].id)
                }

                setBairro(dadosCEP.data.bairro)
                setComplemento(dadosCEP.data.complemento)
                setEndereco(dadosCEP.data.logradouro)

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível consultar o CEP. Por favor, tente novamente`)

        } finally {
            setLoadingConsultaCEP(false)
        }
    }

    const logradouroChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEndereco(e.target.value)
    }

    const bairroChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBairro(e.target.value)
    }

    const numeroChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumero(e.target.value.replace(/[^0-9]/g, ''))
    }

    const complementoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        console.log('complemento '+ e.target.value)
        setComplemento(e.target.value)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ESTADO --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearUfSelecionada = useCallback(() => {

        setSiglaUf("")
        setIdUf(0)

        updateUfList()

        setCidade([])
        setIdCity(0)

        //clickSearchBoxCidade()
        setVisibleSearchBoxUF(false)
        boxFocusUF()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */
    }, [attributes?.estados])

    const handleFilterUfClick = useCallback(async (description: string) => {

        if (description === "") {

            updateUfList()
        } else {

            const newUfList = [...attributes?.estados || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setUf(newUfList || [])
        }

    }, [attributes?.estados])

    const handleUfSelectClick = useCallback((v: Estado) => {

        if (v.id > 0) {

            setIdUf(v.id)
            setSiglaUf(v.sigla)
            setarCidades(v.sigla)

        } else {
            setIdUf(0)
            setSiglaUf('')
            setarCidades('')
        }

        updateUfList()

        setIdCity(0)

        setVisibleSearchBoxUF(false)
        boxFocusUF()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */

    }, [attributes?.estados])

    const updateUfList = () => {
        const newUfList = [...attributes?.estados || []]
        setUf(newUfList)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CIDADE --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearCidadeSelecionada = useCallback(() => {

        setIdCity(0)
        setarCidades(siglaUf)

        setVisibleSearchBoxCity(false)
        boxFocusCidade()

        /*
        if (idUf === 0) {
            const newCidadeList = [...attributes?.cidades || []]
            setCidade(newCidadeList)
            setIdCity(0)
        }
        */
    }, [uf, siglaUf])

    const handleFilterCidadeClick = useCallback(async (description: string) => {

        if (description.trim() === "") {


            setarCidades(siglaUf)
            //const newCidadeList = [...attributes?.cidades || []]
            //setCidade(newCidadeList)

        } else {

            let newCidadeList = []

            newCidadeList = [...attributes?.cidades || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.trim().toLocaleLowerCase()) &&
                    item.uf === siglaUf
            })

            setCidade(newCidadeList)

            /*
            if (idUf > 0) {
                newCidadeList = [...attributes?.cidades || []].filter((item) => {
                    return item.description.toLocaleLowerCase().startsWith(description.trim().toLocaleLowerCase()) &&
                        item.uf === siglaUf
                })

            } else {

                newCidadeList = [...attributes?.cidades || []].filter((item) => {
                    return item.description.toLocaleLowerCase().startsWith(description.trim().toLocaleLowerCase())
                })
            }
            */
        }

    }, [uf, siglaUf])

    const handleCidadeSelectClick = useCallback((v: Cidade) => {

        if (v) {
            setIdCity(v.id)
            setarCidades(siglaUf)
        }

        setVisibleSearchBoxCity(false)
        boxFocusCidade()

        /*
        const newCidadeList = [...attributes?.cidades || []]
        setCidade(newCidadeList)
        */
        // setIdCidade(v.codIBGE)
    }, [uf, siglaUf])

    const setarCidades = async (uf: string) => {
        const citys = await attributes?.cidades.filter(item => item.uf === uf)
        setCidade(citys || [])
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CONTATO -------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleChangeNomeContato = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNomeContatoCli(e.target.value)
    }

    const handleChangeEmailContato = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        setEmailContatoCli(value)
    }

    const handleChangeFoneContato = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFoneContatoCli(e.target.value)
    }

    const handleChangeCelContato = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCelContatoCli(e.target.value)
    }

    const handleChangeDescricaoContato = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescricaoContatoCli(e.target.value)
    }

    const InputfocusContato = () => {
        const inputElement = document.getElementById("nome_contato_cli")
        inputElement?.focus()
    }

    const novoContatoCliente = () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setIdContato(0)
        setNomeContatoCli("")
        setEmailContatoCli("")
        setDescricaoContatoCli("")
        setFoneContatoCli("")
        setCelContatoCli("")

        setListContato([])

        const inputContactName = document.getElementById('nome_contato_cli')

        if (inputContactName) {
            inputContactName.focus()
        }
    }

    const handleContatoSave = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setLoading(true)

        try {

            const contato: ContatoCliente = {
                id: idContato,
                nome: nomeContatoCli,
                email: emailContatoCli,
                descricao: descricaoContatoCli,
                telefone: foneContatoCli,
                celular: celContatoCli,
                id_cliente: id,
            }

            if (id === 0) {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(`Favor salvar um cliente antes de cadastrar um contato`)
                    clearTimeout(timer)
                }, 250)

            } else {

                const retAPI = await ClientesService.CreateContact(contato)

                if (retAPI.error) {

                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(retAPI.msg || ``)

                } else {

                    setVisible(true)
                    setIdContato(retAPI.id || 0)
                    setMessageType('SUCCESS')
                    setMessage(idContato > 0 ? `Dados do contato atualizados com sucesso` : retAPI.msg || ``)

                    uppContacts()

                    setIdContato(0)
                    setNomeContatoCli("")
                    setEmailContatoCli("")
                    setDescricaoContatoCli("")
                    setFoneContatoCli("")
                    setCelContatoCli("")
                }
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(idContato > 0 ? `Não foi possível atualizar os dados do contato. Por favor, tente novamente` : `Não foi possível salvar os dados do contato. Por favor, tente novamente`)

        } finally {

            InputfocusContato()
            setListContato([])
            setLoading(false)
        }
    }

    const handleContactEdit = useCallback((item: ContatoCliente) => {

        if (listContato.length > 0) {
            setListContato([])
        }

        setMessageType((prevMessageType) => {
            if (prevMessageType === 'DANGER') {
                setVisible(false)
            }
            return prevMessageType // Mantém o valor inalterado
        })

        setIdContato(item.id || 0)
        setNomeContatoCli(item.nome || '')
        setEmailContatoCli(item.email || '')
        setDescricaoContatoCli(item.descricao || '')
        setFoneContatoCli(item.telefone || '')
        setCelContatoCli(item.celular || '')

        setListContato([item])
        InputfocusContato()

    }, [listContato])

    const uppContacts = async () => {

        if (parseInt(idCliente || id.toString()) > 0) {

            try {

                const newContactsList = await ClientesService.BuscarContatos(parseInt(idCliente || id.toString()) || 0)
                setCliente(newContactsList.data)

            } catch (error) {

                setVisible(true)
                setMessageType('DANGER')
                setMessage(`Houve um erro ao buscar os contatos atualizados`)

            }
        }
    }

    const handleExcluirClick = useCallback(async (item: ContatoCliente) => {

        setMessageType((prevMessageType) => {
            if (prevMessageType === 'DANGER') {
                setVisible(false)
            }
            return prevMessageType // Mantém o valor inalterado
        })

        setModalShow(true)
        setIdExcluir(item.id || 0)
        setNomeContatoExcluir(item.nome || '')

        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

        if (divPerfil) {
            divPerfil.classList.add('hidden')
        }
    }, [])

    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setVisible(false)
        setLoadingExcluir(true)

        try {

            const retAPI = await ClientesService.DeleteContato(idExcluir, motivo, senha)

            if (!retAPI.error) {

                handleReloatContacts()

                if (idContato === idExcluir) {
                    novoContatoCliente()
                }

                const timer = setTimeout(() => {
                    setModalShow(false)
                    clearTimeout(timer)
                }, 1000)

            } else {

                handleReloatContactsError(retAPI.msg || 'Erro ao exlcuir')
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível excluir o contato. Por favor, tente novamente`)

        } finally {
            setLoadingExcluir(false)
        }

    }, [idExcluir, idContato])

    const handleReloatContacts = async () => {
        setVisible(false)

        const timer = setTimeout(() => {
            setVisible(true)
            setMessageType("SUCCESS")
            setMessage(`Contato excluído com sucesso`)
            uppContacts()

        }, 150)

        return () => clearTimeout(timer)
    }

    const handleReloatContactsError = async (msg: string) => {
        setVisible(false)

        const timer = setTimeout(() => {
            setVisible(true)
            setMessageType("DANGER")
            setMessage(msg)
            uppContacts()
        }, 150)

        return () => clearTimeout(timer)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- AUDITORIA ------------------------------------------------------------------------ ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const abrirModalContatoAuditoria = useCallback((item: ContatoCliente) => {
        setListAuditoriaContato(item)
        setModalAuditoriaVisible(true)

        setMessageType((prevMessageType) => {
            if (prevMessageType === 'DANGER') {
                setVisible(false)
            }
            return prevMessageType // Mantém o valor inalterado
        })

    }, [])

    const fecharModalAuditoria = useCallback(() => {
        setModalAuditoriaVisible(false)
    }, [])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CLIENTE -------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const novoCliente = () => {

        //setSiglaUf("")
        //setarCidades('')
        //const newCidadeList = [...attributes?.cidades || []]
        //setCidade(newCidadeList)

        setId(0)
        setTipoPessoa("F")
        setCpfCnpj("")
        setNomeRazao("")
        setNomeFantasia("")
        setIeRg("")
        setAtivo("S")
        setDtNascimento("")
        setObservacao("")
        setCep("")
        setEndereco("")
        setBairro("")
        setNumero("")
        setComplemento("")
        setIdCity(0)

        updateUfList()
        dadosEmpresaLogada()

        setCliente([])

        setDtCriador('')
        setUserCriador('')
        setDtAtt('')
        setUsertAtt('')

        searchBoxFocus()

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        redefinirCampos()
        inputFocus()
    }

    const handleSaveCliente = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setLoading(true)
        searchBoxFocus()

        try {

            let cliente = {
                id: id,
                tipo_pessoa: tipoPessoa,
                cnpj_cpf: Funcoes.FormatDoc(cpfCnpj),
                nome: nomeRazao,
                nome_fantasia: nome_fantasia,
                ie_rg: ieRg,
                ativo: ativo === 'S' ? 'S' : 'N',
                observacao: observacao,
                cep: cep != '' && cep.length === 8 ? Funcoes.FormatCep(cep) : '',
                endereco: endereco,
                bairro: bairro,
                numero: numero,
                complemento: complemento,
                id_cidade: idCity,
                uf: siglaUf,
                dt_nascimento: dtNascimento
            }

            if (cep.length > 0 && cep.length < 8) {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(`CEP inválido`)
                    clearTimeout(timer)
                }, 250)

                return
            }

            const resp = await ClientesService.Save(cliente)

            if (resp.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(resp.msg || ``)
                //checkDadosObrigatorios(resp.field || '')

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setId(resp.id || 0)
                setMessage(id > 0 ? `Dados do cliente atualizados com sucesso` : resp.msg || ``)

                if (resp.dt_cadastro) {
                    const dataFormatadaCriacao = moment(resp.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (resp.dt_last_update) {
                    const dataFormatadaAtt = moment(resp.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setNomeRazaoCopia(resp.data.cliente.nome)
                setUserCriador(resp.name_user_insert || '')
                setUsertAtt(resp.name_user_last_update || '')

                redefinirCampos()
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(id > 0 ? `Não foi possível atualizar os dados do cliente. Por favor, tente novamente` : `Não foi possível salvar os dados do cliente. Por favor, tente novamente`)

        } finally {
            const timer = setTimeout(() => {
                setLoading(false)
                inputFocus()
                clearTimeout(timer)
            }, 1200)
        }

    }

    const abrirModalConsultaCNPJ = () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setModalConsultaVisible(true)
        searchBoxFocus()
    }

    const fecharModalConsultaCNPJ = useCallback(() => {
        setVisible(false)
        setModalConsultaVisible(false)
        inputFocus()
    }, [])

    const inputFocusCNPJ = () => {
        const inputElement = document.getElementById("inputCNPJ")
        inputElement?.focus()
    }

    const handleConsultarCNPJ = useCallback(async (CNPJ: string) => {

        setVisible(false)
        setLoadingCnpj(true)

        try {

            if (CNPJ !== '' && cnpj.isValid(CNPJ)) {

                const dadosCNPJ: DadosCNPJ = await UtilServices.ConsultarCNPJ(CNPJ)

                if (dadosCNPJ.razao) {

                    updateUfList()

                    setNomeRazao(dadosCNPJ.razao || '')
                    setNomeFantasia(dadosCNPJ.fantasia || dadosCNPJ.razao)
                    setEndereco(dadosCNPJ.logradouro || '')
                    setBairro(dadosCNPJ.bairro || '')
                    setNumero(dadosCNPJ.numero?.toString() || '')
                    setCep(dadosCNPJ.cep.replaceAll('.', '').replaceAll('-', '') || '')
                    setComplemento(dadosCNPJ.compl || '')
                    setBairro(dadosCNPJ.bairro || '')
                    setCpfCnpj(dadosCNPJ.cnpj.replaceAll('.', '').replaceAll('_', '').replaceAll('-', '').replaceAll('/', '') || '')
                    setSiglaUf(dadosCNPJ.uf || '')
                    setarCidades(dadosCNPJ.uf || '')
                    setIdUf(dadosCNPJ.id_uf || 0)
                    setIdCity(dadosCNPJ.id_cidade || 0)
                    setAtivo('S')
                    setTipoPessoa('J')
                    setModalConsultaVisible(false)

                } else {

                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(`Erro ao localizar CNPJ`)

                    inputFocusCNPJ()
                }

            } else {

                const timer = setTimeout(() => {
                    setVisible(true)
                    setMessageType('DANGER')
                    setMessage(`CNPJ inválido`)
                    setLoadingCnpj(false)

                    inputFocusCNPJ()
                    clearTimeout(timer)
                }, 250)
            }

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Não foi possível consultar o CNPJ. Por favor, tente novamente`)

            inputFocusCNPJ()

        } finally {
            setLoadingCnpj(false)
        }

    }, [attributes?.estados])

    const checkDadosObrigatorios = (field: string): boolean => {

        if (cpfCnpj.trim() === '' || (tipoPessoa === 'F' && (!(cpf.isValid(cpfCnpj)) || !(cpfCnpj.replaceAll(".", "").replaceAll("-", "").replaceAll("_", "").length === 11))) || (tipoPessoa === 'J' && (!(cnpj.isValid(cpfCnpj)) || !(cpfCnpj.replaceAll(".", "").replaceAll("/", "").replaceAll("-", "").replaceAll("_", "").length === 14)))) {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (nomeRazao.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (ieRg.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (endereco.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (bairro.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (siglaUf.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (idCity <= 0) {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === field ? true : false }
            })
            setCamposObrigatorios(fieldsM)
            return true
        }

        return false
    }

    const redefinirCampos = async () => {
        let fieldsM: CampoObrigatorio[] = [
            { campo: 'cnpj_cpf', erro: false },     // Posição 0 do Array.
            { campo: 'nome', erro: false },         // Posição 1 do Array.
            { campo: 'ie_rg', erro: false },        // Posição 2 do Array.
            { campo: 'endereco', erro: false },     // Posição 3 do Array.  
            { campo: 'bairro', erro: false },       // Posição 4 do Array.  
            { campo: 'estado', erro: false },       // Posição 5 do Array. 
            { campo: 'cidade', erro: false },       // Posição 6 do Array. 
        ]

        setCamposObrigatorios(fieldsM)
    }

    const inputFocus = () => {
        const inputElement = document.getElementById("cnpj_cpf_cliente")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- MODALS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const fecharModalExclusao = useCallback(() => {

        if (messageType == 'SUCCESS') {
            setModalShow(false)
        }

        setVisible(false)
    }, [messageType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setVisible(false)
        setModalShow(false)
    }, [])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 1 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefs: InputsRefs = {
        tipoPessoa: useRef(null),
        cpfCnpj: useRef(null),
        nomeRazao: useRef(null),
        nomeFantasia: useRef(null),
        ieRg: useRef(null),
        ativo: useRef(null),
        dtNascimento: useRef(null),
        observacao: useRef(null),
        cep: useRef(null),
        endereco: useRef(null),
        bairro: useRef(null),
        numero: useRef(null),
        complemento: useRef(null),
        uf: useRef(null),
        cidade: useRef(null),
        estoque: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[0].active) {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            searchBoxFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs) as (keyof typeof inputsRefs)[];

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefs[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            //console.log("next: ", nextIndex)

            if (nextIndex === 13) {
                setVisibleSearchBoxUF(true)
                inputFocusUF()
            }

            if (nextIndex === 14) {
                setVisibleSearchBoxCity(true)
                inputFocusCidade()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefs[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }
        }
    }

    useEffect(() => {

        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab' && tabs[0].active) {

                event.preventDefault()

                const inputSearchUf = document.getElementById('inputSearchBox-uf') as HTMLInputElement
                const inputSearchCidade = document.getElementById('inputSearchBox-cidade') as HTMLInputElement

                if (document.activeElement === inputSearchUf) {

                    clickSearchBoxCidade()
                    setVisibleSearchBoxUF(false)

                } else if (document.activeElement === inputSearchCidade) {
                    inputsRefs['tipoPessoa'].current?.focus()
                    setVisibleSearchBoxCity(false)
                }
            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }

    }, [tabs])

    const searchBoxFocus = () => {
        setVisibleSearchBoxUF(false)
        setVisibleSearchBoxCity(false)
    }

    // UF -------------------------------------------------
    const boxFocusUF = () => {
        // Move o foco para o input correspondente à chave 'uf'.
        inputsRefs['uf'].current?.focus()
    }

    const clickSearchBoxUF = useCallback(() => {
        setVisibleSearchBoxUF((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxCity(false) // Fecha o City ao abrir UF
                inputFocusUF() // Foca no input UF ao abrir
            }
            return newState
        })

        boxFocusUF() // Sempre executa ao clicar
    }, [])

    const inputFocusUF = () => {
        let inputSearch = document.getElementById(`inputSearchBox-uf`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // CIDADE -----------------------------------------------
    const boxFocusCidade = () => {
        // Move o foco para o input correspondente à chave 'cidade'.
        inputsRefs['cidade'].current?.focus()
    }

    const clickSearchBoxCidade = useCallback(() => {
        setVisibleSearchBoxCity((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                setVisibleSearchBoxUF(false) // Fecha o UF ao abrir City
                inputFocusCidade() // Foca no input Cidade ao abrir
            }
            return newState
        })

        boxFocusCidade() // Sempre executa ao clicar
    }, [])

    const inputFocusCidade = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cidade`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 2 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefsContato: InputsRefs = {
        nomeContato: useRef(null),
        emailContato: useRef(null),
        telefoneContato: useRef(null),
        celularContato: useRef(null),
        descricaoContato: useRef(null),
    }

    const handleTabPressContato = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[1].active) {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefsContato)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefsContato[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefsContato[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }

        }
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 3 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab' && (tabs[2].active)) {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- IMPORTAÇÃO ----------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const abrirModalImportacao = () => {
        setVisibleImportacao(true)

        if (messageType === 'DANGER') {
            setVisible(false)
        }
    }

    const fecharModalImportacao = useCallback(() => {
        setVisibleImportacao(false)
        setVisible(false)

        if (tabs[0].active) {
            inputFocus()
        } else {
            InputfocusContato()
        }
    }, [tabs])

    const formFields = [
        { pl: "Pessoa", bd: "tipo_pessoa" },
        { pl: "CPF / CNPJ", bd: "cnpj_cpf" },
        { pl: "Nome / Razão Social", bd: "nome" },
        { pl: "Nome Fantasia / Apelido", bd: "nome_fantasia" },
        { pl: "Insc. Estadual / RG", bd: "ie_rg" },
        { pl: "Data de Nascimento", bd: "dt_nascimento" },
        { pl: "Observação", bd: "observacao" },
        { pl: "CEP", bd: "cep" },
        { pl: "Logradouro", bd: "endereco" },
        { pl: "Bairro", bd: "bairro" },
        { pl: "Número", bd: "numero" },
        { pl: "Complemento", bd: "complemento" },
        { pl: "UF", bd: "uf" },
        { pl: "Cidade", bd: "id_cidade" },
    ]

    const importarDados = useCallback(async (planilha: any, mapa: any) => {

        setVisible(false)
        setLoading(true)

        try {

            const dados = await ClientesService.ClienteImportacao(planilha, mapa)

            if (dados.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(`Planilha de importação não enviada`)

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setMessage(`Dados importados com sucesso`)

                setVisibleImportacao(false)
                inputFocus()
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível concluir a importação. Por favor, tente novamente`)

        } finally {
            setLoading(false)
        }

    }, [])

    const maskTipoPessoa = tipoPessoa !== '' && tipoPessoa === 'F' ? '999.999.999-99' : '99.999.999/9999-99'
    const ativoEdit = parseInt(idCliente || '0') > 0 ? false : true
    const btNovoVisible = parseInt(idCliente || '') > 0 ? 'invisible hidden' : 'visible'

    const condCnpjCpf = tipoPessoa === 'F' && cpf.isValid(cpfCnpj) ? bgBlue : tipoPessoa === 'J' && cnpj.isValid(cpfCnpj) ? bgBlue : bgRed
    const condCell = celContatoCli.replace(/[()_\s-]/g, '').length === 11 && celContatoCli.replace(/[()_\s-]/g, '') != '' || foneContatoCli.replace(/[()_\s-]/g, '') != '' ? bgBlue : bgRed
    const condFone = foneContatoCli.replace(/[()_\s-]/g, '').length === 10 && foneContatoCli.replace(/[()_\s-]/g, '') != '' || celContatoCli.replace(/[()_\s-]/g, '') != '' ? bgBlue : bgRed

    return (
        <Template isLoading={loading} >

            <div className={`${classDivBackground}`} >

                <div id='div-body' className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`grid grid-cols-12`}>

                            <div className={`col-span-10 xl:col-span-11 h-[50px] w-full flex items-center my-3 px-2`}>
                                <FcNook className={`text-slate-700 dark:text-slate-200 ml-2 mr-2`} size="25px" color='#333' />
                                <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all mx-2`}>{parseInt(idCliente || '') || id > 0 ? `Editar - Cliente - ${nomeRazaoCopia}` : `Cadastro - Cliente`}</span>
                                <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} shadow-md shadow-blue-600`}  >
                                    <FaVideo />
                                    <span className='mx-1'>Tutorial</span>
                                </button>
                            </div>

                            <div className={`col-span-2 xl:col-span-1 h-[50px] w-full flex items-center my-3 px-2`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} data-tooltip-id={'tooltip-btn-dados'} id={'btn-dados'} onClick={abrirModalImportacao}>
                                    <FaFileDownload size="25px" />
                                    <Tooltip style={{ backgroundColor: user.modeDark === 'dark' ? '#B6B060' : '#166794' }} id={'tooltip-btn-dados'} anchorSelect={'#btn-dados'} positionStrategy="fixed" place='left' >
                                        <span>Importar Dados</span>
                                    </Tooltip>
                                </button>
                            </div>

                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`h-[60px] flex overflow-x-auto scrollable_horizontal border border-slate-200 dark:border-slate-700`}>
                                {tabs.map((item) => {
                                    return (
                                        <button tabIndex={-1} onClick={() => handleChangeTab(item.index)} key={item.index.toString()}
                                            className={`px-4 font-mono font-bold w-[180px]
                                                ${item.active ?
                                                    `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                    `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                } `}>
                                            <div tabIndex={-1} className={`flex items-center`}>
                                                <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                <span className={`text-sm roboto whitespace-nowrap`}>{item.titulo}</span>
                                            </div>
                                        </button>
                                    )
                                })}

                            </div>

                            <div className={`${tabs[0].active ? `block` : `hidden`} relative`}>

                                <div className={`flex flex-col sm:flex-row`}>

                                    <div className={`w-full h-full grid gap-5 grid-cols-12 p-4`}>

                                        <div className={`relative col-span-12 space-y-1`}>
                                            <div className={`flex flex-row `}>
                                                <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>Dados Pessoais</span>
                                                <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 `} size={18} />
                                                <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                    <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                                </Tooltip>
                                            </div>
                                            <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-5 md:col-span-4 xl:col-span-3`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue} `} />

                                            <select ref={inputsRefs.tipoPessoa} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'tipoPessoa')} id="tipoPessoa_cliente" className={`${classInput} ${classInputDark}`} autoComplete='off' value={tipoPessoa} onFocus={searchBoxFocus} onChange={tipoPessoaChange}>
                                                <option value="F">Física</option>
                                                <option value="J">Jurídica</option>
                                            </select>
                                            <label htmlFor="tipoPessoa_cliente" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Pessoa</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-7 md:col-span-8 xl:col-span-4`}>
                                            <div className={`${barraVermelhoAzul} ${condCnpjCpf}`} />

                                            <InputMask ref={inputsRefs.cpfCnpj} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'cpfCnpj')} id="cnpj_cpf_cliente" className={`${classInput} ${classInputDark} ${condCnpjCpf == 'bg-red-900' ? focusRed : ``} `} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={cpfCnpj} onFocus={searchBoxFocus} onChange={cpfCnpjChange} mask={maskTipoPessoa} alwaysShowMask={true} />
                                            <label htmlFor="cnpj_cpf_cliente" className={` ${classLabel} ${classLabelDark} ${classBorderLabelDark} ${condCnpjCpf == 'bg-red-900' ? focusLabelRed : ``}`}> {tipoPessoa !== '' && tipoPessoa === 'F' ? `CPF` : `CNPJ`}</label>
                                        </div>

                                        <div className={`relative col-span-12 xl:col-span-7`}>
                                            <div className={`${barraVermelhoAzul} ${nomeRazao != '' ? bgBlue : bgRed} `} />

                                            <input ref={inputsRefs.nomeRazao} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'nomeRazao')} id="nome_cliente" className={`${classInput} ${classInputDark} ${nomeRazao == '' ? focusRed : ''}`} type='text' inputMode='text' maxLength={155} placeholder=" " autoComplete='off' value={nomeRazao} onFocus={searchBoxFocus} onChange={nomeRazaoChange} />
                                            <label htmlFor="nome_cliente" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${nomeRazao == '' ? focusLabelRed : ''}`}>{tipoPessoa !== '' && tipoPessoa === 'F' ? `Nome` : `Razão Social`}</label>
                                        </div>

                                        <div className={`relative col-span-12 xl:col-span-5`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />

                                            <input ref={inputsRefs.nomeFantasia} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'nomeFantasia')} id="fantasia_cliente" className={`${classInput} ${classInputDark} `} type='text' inputMode='text' maxLength={155} placeholder=" " autoComplete='off' value={nome_fantasia} onFocus={searchBoxFocus} onChange={fantasiaChange} />
                                            <label htmlFor="fantasia_cliente" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>{tipoPessoa != '' && tipoPessoa === 'F' ? `Apelido` : `Nome Fantasia`}</label>
                                        </div>

                                        <div className={`relative col-span-12 xl:col-span-5`}>
                                            <div className={`${barraVermelhoAzul} ${tipoPessoa === 'F' ? bgBlue : ieRg == '' && tipoPessoa === 'J' ? bgRed : bgBlue}`} />

                                            <input ref={inputsRefs.ieRg} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'ieRg')} id="ie_rg_cliente" className={`${classInput} ${classInputDark} ${ieRg == '' && tipoPessoa === 'J' ? focusRed : ``}`} type='text' inputMode='text' maxLength={20} placeholder=" " autoComplete='off' value={ieRg} onFocus={searchBoxFocus} onChange={ieRgChange} />
                                            <label htmlFor="ie_rg_cliente" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${ieRg == '' && tipoPessoa === 'J' ? focusLabelRed : ``}`}>{tipoPessoa === 'J' ? 'Insc. Estadual' : 'RG'}</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue} ${ativoEdit ? `opacity-50` : ``}`} />

                                            <select ref={inputsRefs.ativo} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'ativo')} id="ativo_cliente" disabled={ativoEdit} className={`${classInput} ${classInputDark}  ${parseInt(idCliente || '0') > 0 ? `cursor-pointer` : `cursor-not-allowed`} `} autoComplete='off' value={ativo} onFocus={searchBoxFocus} onChange={ativoChange}>
                                                <option value="S">Sim</option>
                                                <option value="N">Não</option>
                                            </select>
                                            <label htmlFor="ativo_cliente" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Ativo</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-8 xl:col-span-5`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />

                                            <input ref={inputsRefs.dtNascimento} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'dtNascimento')} id='data-nascimento_cliente' className={`${classInput} ${classInputDark} ${dtNascimento === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={dtNascimento} onFocus={searchBoxFocus} onChange={dtNascimentoChange} />
                                            <label htmlFor="data-nascimento_cliente" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>{tipoPessoa !== '' && tipoPessoa === 'F' ? `Data de Nascimento` : `Data de Criação`}</label>
                                        </div>

                                        <div className={`relative col-span-12`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue} bottom-1 dark:bottom-1`} />

                                            <textarea ref={inputsRefs.observacao} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'observacao')} id="obs_cliente" className={`${classInput} ${classInputDark} min-h-[160px] lg:min-h-[120px] resize-none`} placeholder=" " autoComplete='off' value={observacao} onFocus={searchBoxFocus} onChange={observacaoChange} />
                                            <label htmlFor="obs_cliente" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Observação</label>
                                        </div>

                                    </div>

                                    <div className={`w-full sm:h-[50px] grid gap-5 grid-cols-12 p-4`}>

                                        <div className={`relative col-span-12 space-y-1`}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300`}>Endereço</span>
                                            <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-5 lg:col-span-4 xl:col-span-3`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue} `} />

                                            <div className='absolute flex items-center h-full px-2'>

                                                {loadingConsultaCEP &&
                                                    <div className={`absolute h-[20px] w-[20px] animate-spin rounded-full ml-1 border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                        <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                    </div>
                                                }

                                            </div>
                                            <InputMask ref={inputsRefs.cep} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'cep')} id="cep_cliente" className={`${classInput} ${classInputDark} ${loadingConsultaCEP ? 'pl-10' : ''}`} type='text' inputMode='numeric' placeholder=" " autoComplete='off' value={cep} onFocus={searchBoxFocus} onChange={cepChange} mask={'99999-999'} alwaysShowMask={true} />
                                            <label htmlFor="cep_cliente" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>CEP</label>
                                        </div>

                                        <div className={`relative col-span-12`}>

                                            <div className={`${barraVermelhoAzul} ${endereco != '' ? bgBlue : bgRed} `} />
                                            <input ref={inputsRefs.endereco} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'endereco')} id="endereco" className={`${classInput} ${classInputDark} ${endereco == '' ? focusRed : ``}`} type='text' inputMode='text' maxLength={155} placeholder=" " autoComplete='off' value={endereco} onFocus={searchBoxFocus} onChange={logradouroChange} />
                                            <label htmlFor="endereco" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${endereco == '' ? focusLabelRed : ``}`}>Logradouro</label>
                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-8 xl:col-span-6`}>

                                            <div className={`${barraVermelhoAzul} ${bairro != '' ? bgBlue : bgRed}`} />
                                            <input ref={inputsRefs.bairro} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'bairro')} id="bairro_cliente" className={`${classInput} ${classInputDark} ${bairro == '' ? focusRed : ``}`} type='text' inputMode='text' maxLength={60} placeholder=" " autoComplete='off' value={bairro} onFocus={searchBoxFocus} onChange={bairroChange} />
                                            <label htmlFor="bairro_cliente" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${bairro == '' ? focusLabelRed : ``}`}>Bairro</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-4 xl:col-span-2`}>

                                            <div className={`${barraVermelhoAzul} ${bgBlue} `} />
                                            <input ref={inputsRefs.numero} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'numero')} id="numero_cliente" className={`${classInput} ${classInputDark}`} type='text' inputMode='numeric' maxLength={20} placeholder=" " autoComplete='off' value={numero} onFocus={searchBoxFocus} onChange={numeroChange} />
                                            <label htmlFor="numero_cliente" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Número</label>
                                        </div>

                                        <input
                                            type="text"
                                            name="fake_autofill_field"
                                            style={{ display: 'none' }}
                                            autoComplete="username"
                                        />

                                        <div className={`relative col-span-12 sm:col-span-8 md:col-span-8 lg:col-span-5 xl:col-span-4`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue} `} />
                                            <input ref={inputsRefs.complemento} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'complemento')} 
                                            id="complemento_cliente" className={`${classInput} ${classInputDark}`} type="text" inputMode='text' maxLength={60} placeholder=" " 
                                               autoComplete='nope' value={complemento} onFocus={searchBoxFocus} onChange={complementoChange} />
                                            <label htmlFor="complemento_cliente" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Complemento</label>
                                        </div>

                                        <div className={`relative col-span-12 lg:col-span-7 xl:col-span-6`}>

                                            <div ref={inputsRefs['uf']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'uf')} />
                                            <div className={`${barraVermelhoAzul} ${idUf > 0 ? bgBlue : bgRed}`} />
                                            <SearchBox
                                                dataList={uf}
                                                idRegistro={idUf || undefined}
                                                label='Estado'
                                                componentId='uf'
                                                borda={true}
                                                visibleTAB={visibleSearchBoxUF}
                                                clearDataClick={handleClearUfSelecionada}
                                                setDataClick={handleUfSelectClick}
                                                filterDataClick={handleFilterUfClick}
                                                clicado={clickSearchBoxUF}
                                            />

                                        </div>

                                        <div className={`relative col-span-12 xl:col-span-6`}>

                                            <div ref={inputsRefs['cidade']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'cidade')} />
                                            <div className={`${barraVermelhoAzul} ${idCity > 0 ? bgBlue : bgRed}`} />
                                            <SearchBox
                                                dataList={cidade}
                                                idRegistro={idCity || undefined}
                                                label='Cidade'
                                                componentId='cidade'
                                                borda={true}
                                                visibleTAB={visibleSearchBoxCity}
                                                clearDataClick={handleClearCidadeSelecionada}
                                                setDataClick={handleCidadeSelectClick}
                                                filterDataClick={handleFilterCidadeClick}
                                                clicado={clickSearchBoxCidade}

                                            />

                                        </div>

                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <div className={`flex flex-col lg:flex-row ${parseInt(idCliente || '0') > 0 ? `sm:space-y-0 lg:space-x-0 space-y-1` : `lg:space-y-0 lg:space-x-4 space-y-4`}`}>

                                        <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/cliente" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                            <BsBoxArrowInLeft size="20px" className={`mr-[5px]`} /> Voltar
                                        </Link>

                                        <button tabIndex={-1} onClick={abrirModalConsultaCNPJ} className={` ${parseInt(idCliente || '') > 0 || id > 0 || tabs[1].active ? `invisible hidden` : `visible`} ${classbtColunasAzul} ${classWeigthBt}`}>
                                            <span>Consultar CNPJ</span>
                                        </button>

                                    </div>

                                    <div className={`flex flex-col lg:flex-row ${parseInt(idCliente || '0') > 0 ? `sm:space-y-0 lg:space-x-0 space-y-1` : `lg:space-y-0 lg:space-x-4 space-y-4`}`}>

                                        <button tabIndex={-1} onClick={novoCliente} className={`${classBt} ${btNovoVisible} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                            <AiOutlineClear size="20px" className={`mr-[5px]`} />Limpar Campos
                                        </button>

                                        <button tabIndex={-1} onClick={handleSaveCliente} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt}`}>
                                            {!loading && <IoSave size="16px" className={`mr-[5px]`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {parseInt(idCliente || '0') > 0 || id != 0 ? !loading ? `Atualizar` : `Aguarde` : !loading ? `Salvar` : `Aguarde`}
                                        </button>

                                    </div>

                                </div>

                            </div>

                            <div className={`${tabs[1].active ? `block` : `hidden`} relative`}>

                                <div className={`w-full h-full grid gap-5 grid-cols-12 p-4 mt-3`}>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-3`}>
                                        <div className={`${barraVermelhoAzul} ${nomeContatoCli != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefsContato.nomeContato} onKeyDown={(e: React.KeyboardEvent) => handleTabPressContato(e, 'nomeContato')} id="nome_contato_cli" className={`${classInput} ${classInputDark} ${nomeContatoCli == '' ? focusRed : ``}`} type='text' inputMode='text' maxLength={155} placeholder=" " autoComplete='off' value={nomeContatoCli} onChange={handleChangeNomeContato} />
                                        <label htmlFor="nome_contato_cli" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${nomeContatoCli == '' ? focusLabelRed : ``}`}>Nome do Contato</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-3`}>

                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefsContato.emailContato} onKeyDown={(e: React.KeyboardEvent) => handleTabPressContato(e, 'emailContato')} id="email_contato_cli" className={`${classInput} ${classInputDark} ${idContato != 0 && listContato[0]?.email ? `cursor-not-allowed` : ''}`} type='email' inputMode='email' maxLength={155} placeholder=" " autoComplete='off' value={emailContatoCli} disabled={idContato != 0 && listContato[0]?.email ? true : false} onChange={handleChangeEmailContato} />
                                        <label htmlFor="email_contato_cli" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>E-mail</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2`}>

                                        <div className={`${barraVermelhoAzul} ${condFone}`} />
                                        <InputMask ref={inputsRefsContato.telefoneContato} onKeyDown={(e: React.KeyboardEvent) => handleTabPressContato(e, 'telefoneContato')} id="fone_contato_cli" className={` ${classInput} ${classInputDark} ${condFone == 'bg-red-900' ? focusRed : ``} `} type='tel' inputMode='tel' placeholder=" " autoComplete='off' value={foneContatoCli} onChange={handleChangeFoneContato} mask="(99) 9999-9999" alwaysShowMask={true} />
                                        <label htmlFor="fone_contato_cli" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${condFone == 'bg-red-900' ? focusLabelRed : ``} `}>Telefone</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2`}>

                                        <div className={`${barraVermelhoAzul} ${condCell}`} />
                                        <InputMask ref={inputsRefsContato.celularContato} onKeyDown={(e: React.KeyboardEvent) => handleTabPressContato(e, 'celularContato')} id="celular_contato_cli" className={`${classInput} ${classInputDark} ${condCell == 'bg-red-900' ? focusRed : ``}`} type='tel' inputMode='tel' placeholder=" " autoComplete='off' value={celContatoCli} onChange={handleChangeCelContato} mask="(99) 99999-9999" alwaysShowMask={true} />
                                        <label htmlFor="celular_contato_cli" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${condCell == 'bg-red-900' ? focusLabelRed : ``}`}>Celular</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6 xl:col-span-2`}>

                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefsContato.descricaoContato} onKeyDown={(e: React.KeyboardEvent) => handleTabPressContato(e, 'descricaoContato')} id="descricao_contato_cli" className={`${classInput} ${classInputDark} `} type='text' inputMode='text' maxLength={155} placeholder=" " autoComplete='off' value={descricaoContatoCli} onChange={handleChangeDescricaoContato} />
                                        <label htmlFor="descricao_contato_cli" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Descrição</label>
                                    </div>

                                </div>

                                <div className={`relative overflow-hidden hover:overflow-auto p-4`}>

                                    <GridContatoCliente
                                        cliente={cliente}
                                        auditoriaContact={abrirModalContatoAuditoria}
                                        editContact={handleContactEdit}
                                        excluirContact={handleExcluirClick} />

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <Link onMouseUp={handleMouseUp} tabIndex={-1} to="/cliente" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className={`mr-[5px]`} /> Voltar
                                    </Link>

                                    <button onClick={novoContatoCliente} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className={`text-white mr-[5px]`} />Limpar Campos
                                    </button>

                                    <button onClick={handleContatoSave} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt}`}  >
                                        {!loading && <IoSave size="16px" className={`mr-[5px]`} />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {idContato != 0 ? !loading ? `Atualizar` : `Aguarde` : !loading ? `Salvar` : `Aguarde`}
                                    </button>

                                </div>

                            </div>

                            <div className={`${tabs[2].active ? `block` : `hidden`} relative h-[400px] sm:h-[200px]`}>

                                <div className={`w-full h-full flex flex-row p-4`}>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userCriacaoCli" className={`${classUserCriarAtt}`}>Criador</label>
                                            <span id="userCriacaoCli" className={`${classDtCriarAtt}`}>{userCriador}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtCriacaoCli" className={`${classUserCriarAtt}`}>Data de Criação</label>
                                            <span id="dtCriacaoCli" className={`${classDtCriarAtt}`} >{dtCriador}</span>
                                        </div>

                                    </div>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userAttCli" className={`${classUserCriarAtt}`}>Atualizador</label>
                                            <span id="userAttCli" className={`${classDtCriarAtt}`} >{usertAtt}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtAttCli" className={`${classUserCriarAtt}`}>Data de Atualização</label>
                                            <span id="dtAttCli" className={`${classDtCriarAtt}`} >{dtAtt}</span>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <ModalConsultaCNPJ
                        visible={modalConsultaVisible}
                        loading={loadingCnpj}
                        CloseModalEvent={fecharModalConsultaCNPJ}
                        ConsultarCNPJEvent={handleConsultarCNPJ}
                    />

                    <ModalExcluirDados
                        show={modalShow}
                        isLoading={loadingExcluir}
                        message={`Deseja excluir o contato - ${nomeContatoExcluir || ''}?`}
                        closeModalEvent={fecharModalExclusao}
                        excluirEvent={handleExcluir}
                        fecharModalEvent={buttonFecharModalExcluirDados}

                    />

                    <ModalAuditoria
                        visible={modalAuditoriaVisible}
                        listaAtributos={listAuditoriaContato}
                        closeModalEvent={fecharModalAuditoria}
                    />

                    <ModalImportacao
                        visible={visibleImportacao}
                        formFields={formFields}
                        closeModalEvent={fecharModalImportacao}
                        importarDados={importarDados}
                    />

                    {modalTutorialVisible &&
                        <ModalTutorial
                            linkVideo='/tutorial_cliente.mp4'
                            title='Como cadastrar um cliente'
                            visible={modalTutorialVisible}
                            onCloseClick={() => setModalTutorialVisible(false)}
                        />
                    }


                </div>

            </div>

        </Template>
    )
}